// frontend/src/pages/OnboardingPage/index.tsx
import React from "react";
import { Outlet } from "react-router";
import { getNoneLayout } from "src/components/layout";
import { RequireScope } from "src/components/RequireScope";
import { PageSuspense } from "src/components/ui/page-suspense";
import { Toaster } from "src/components/ui/toaster";

function OnboardingPage() {
  return (
    <RequireScope scope="read:onboarding">
      <div className="h-screen w-full overflow-auto bg-background">
        <PageSuspense>
          <Outlet />
        </PageSuspense>
        <Toaster />
      </div>
    </RequireScope>
  );
}

// Use no layout (full-screen) for onboarding
OnboardingPage.getLayout = getNoneLayout;

export default OnboardingPage;
